import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/authService';
import { loginSuccess, setLoading, setError, clearError } from '../features/auth/authSlice';

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.auth);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(clearError());
    dispatch(setLoading(true));

    try {
      const data = await login(email, password);
      dispatch(loginSuccess({
        fullName: data.fullName,
        email: data.email,
        mustChangePassword: data.mustChangePassword,
        token: data.token,
        isAdmin: data.isAdmin,
        isSuperAdmin: data.isSuperAdmin,
        canAccessTest: data.canAccessTest,
        tenantId: data.tenantId,
        primaryColor: data.primaryColor,
        secondaryColor: data.secondaryColor,
        logoUrl: data.logoUrl,
        portalTitle: data.portalTitle,
        faviconUrl: data.faviconUrl,
      }));

      if (data.mustChangePassword) {
        navigate('/change-password');
      } else {
        navigate('/');
      }
    } catch (err) {
      dispatch(setError('Email veya şifre hatalı.'));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Avixa Portal</h2>
        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              required
            />
          </div>
          <div style={styles.field}>
            <label>Şifre</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
              required
            />
          </div>
          {error && <p style={styles.error}>{error}</p>}
          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>

          <p style={{ textAlign: 'center', marginTop: '12px', fontSize: '13px' }}>
            <span
              style={styles.link}
              onClick={() => navigate('/forgot-password')}
            >
              Şifremi Unuttum
            </span>
            <span style={styles.divider}>|</span>
            <span
              style={styles.link}
              onClick={() => navigate('/activate')}
            >
              İlk kez giriş yapıyorum
            </span>
          </p>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f0f2f5',
  },
  card: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    width: '360px',
  },
  title: {
    textAlign: 'center',
    marginBottom: '24px',
    color: '#1a1a2e',
  },
  field: {
    marginBottom: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  input: {
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #d9d9d9',
    fontSize: '14px',
  },
  error: {
    color: 'red',
    fontSize: '13px',
    marginBottom: '8px',
  },
  button: {
    width: '100%',
    padding: '10px',
    backgroundColor: '#1a1a2e',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
  },
  link: {
    color: '#1a1a2e',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  divider: {
    margin: '0 8px',
    color: '#ccc',
  },
};

export default LoginPage;